<template>
  <div class="footer">
    <div class="footer-content">
      <p class="copyright">
        © {{ currentYear }} {{ configData.copyright_holder || '兰州中科数字科技有限公司' }} 版权所有
        <span v-if="configData.copyright_address" class="separator">|</span>
        <span v-if="configData.copyright_address">地址：{{ configData.copyright_address }}</span>
        <span v-if="configData.copyright_phone" class="separator">|</span>
        <span v-if="configData.copyright_phone">联系方式：{{ configData.copyright_phone }}</span>
      </p>
      <p class="icp">
        备案号：{{ configData.icpcode || '陇ICP备XXXXXXXX号-1' }}
      </p>
    </div>
  </div>
</template>

<script>
import { getConfigs } from '@/api/config'

export default {
  name: 'Footer',
  data() {
    return {
      configData: {
        copyright_holder: '',
        copyright_address: '',
        copyright_phone: '',
        icpcode: ''
      }
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {
    this.loadFooterConfig()
  },
  methods: {
    /**
     * 加载页脚配置信息
     */
    async loadFooterConfig() {
      try {
        const configKeys = ['copyright_holder', 'copyright_address', 'copyright_phone', 'icpcode']
        const response = await getConfigs(configKeys)
        
        if (response.code === 200 && response.data) {
          this.configData = {
            copyright_holder: response.data.copyright_holder || '',
            copyright_address: response.data.copyright_address || '',
            copyright_phone: response.data.copyright_phone || '',
            icpcode: response.data.icpcode || ''
          }
        }
      } catch (error) {
        console.error('获取页脚配置失败:', error)
        // 保持默认值，不影响页面显示
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background: #ffffff;
  border-top: 1px solid #e4e7ed;
  padding: 16px 20px;
  text-align: center;
  position: relative;
  z-index: 100;
  
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    
    .copyright {
      margin: 0 0 4px 0;
      color: #606266;
      font-size: 14px;
      line-height: 1.4;
      
      .separator {
        margin: 0 8px;
        color: #909399;
      }
    }
    
    .icp {
      margin: 0;
      color: #909399;
      font-size: 12px;
      line-height: 1.4;
    }
  }
}
</style>